const learnMoreFeedBack = [
    {
      pageImg: "/Images/learnMore/learn_more_pop_up.png",
      pageAlt: "Ziggy cannot wait to show you more",
    },
  ];
  
  export default learnMoreFeedBack;